<script>
  import { Link, navigate } from "svelte-routing";
  import NavbarBase from "#lib/NavbarBase.svelte";
  import { UX_MODE } from "#src/env.js";
</script>

<NavbarBase>
  <div slot="center" class="text-gray-400">
    <!-- <div class="hidden lg:block text-sm">
      Accurate shapes in, accurate glass out. See errors before they cost you money.
    </div> -->
  </div>
  <div slot="right" class="flex items-center gap-4">
    <Link to="/login">Log In</Link>
    <button class="btn btn-primary-alt" on:click={() => navigate("/pricing")}>Sign Up</button>
  </div>
</NavbarBase>
